import ngDeps from "@/legacy-services";
import { put, call, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  BULK_CHANGE_COLLAB_STATE_ROUTINE,
  CHANGE_COLLAB_STATE_ROUTINE,
} from "constants/ActionTypes";
import { reloadPosts as reloadPostsAction } from "actions/postsView";

export function* changeCollabState(action: {
  type: { type: string };
  payload: {
    postIds: string[];
    postType: string;
    key: string;
    callback: (ap?: string) => void;
    options?: { skipReload?: boolean };
  };
}) {
  const { type } = action.type;
  const routine =
    type === BULK_CHANGE_COLLAB_STATE_ROUTINE.TRIGGER
      ? BULK_CHANGE_COLLAB_STATE_ROUTINE
      : CHANGE_COLLAB_STATE_ROUTINE;
  const { postIds, postType, key, callback, options } = action.payload;
  // Board drag-and-drop skips the redundant full reload (the SUCCESS reducer
  // already patches the card's status); every other caller (and the bulk path,
  // which has no `options`) keeps the reload.
  const skipReload = options?.skipReload ?? false;
  const { collaborationService } = ngDeps;

  yield put({ type: routine.REQUEST });

  // This was running on bulk change collab state before call (drafts | activities)
  // if (!post.schedule.channel || post.schedule.channel === "")
  //   post.schedule.channel = post._id;
  try {
    yield call(
      collaborationService.updatePostStatusKey,
      postIds,
      postType,
      key
    );
    yield put({
      type: routine.SUCCESS,
      payload: {
        postIds: postIds,
        postType: postType,
        postStatusKey: key,
      },
    });
    if (!skipReload) {
      yield put(reloadPostsAction());
    }

    toast.success("Post Status was successfully updated.");
  } catch (error) {
    console.error("Err updating post status", error);
    toast.error("Post Status was not updated.");

    yield put({
      type: routine.FAILURE,
      error: true,
      payload: error,
    });
  }

  callback?.();
}

export default function* collaborationStatusSagas() {
  yield takeEvery(BULK_CHANGE_COLLAB_STATE_ROUTINE.TRIGGER, changeCollabState);
  yield takeEvery(CHANGE_COLLAB_STATE_ROUTINE.TRIGGER, changeCollabState);
}
